import axiosStripePublicInstance from "../services/axiosStripePublicInstance";
import { COACH_ONBOARD_SUCCESS } from "../entities/Endpoints";

export const coachOnboardApi = async ({ id, offerId }) => {
  try {
    const response = await axiosStripePublicInstance.post(
      `${COACH_ONBOARD_SUCCESS}?id=${id}&offerID=${offerId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to onboard coach.");
  }
};
